import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { createColumn } from 'src/shared/entities/column/create-column'

export function migrateColumn(entity: OldEntityInterface) {
  const column = createColumn({
    parentId: entity.parentId,
    masterBlockId: entity.masterBlockId,
  })
  column.id = entity.id
  column.htmlAttrId = entity.options.attrId
  column.childIds = entity.childIds || []
  column.size = entity.options.size

  if (entity.styles) {
    if (entity.styles.alignSelf) {
      column.alignSelf = entity.styles.alignSelf
    }
  }

  return column
}
